module.exports = __webpack_public_path__ + "img/outdoor1.9a10b63e.png";